
import styled from 'styled-components'

export const Container = styled.div`
    background: #fff;
    border-radius: 8px;
    z-index: 1;
    max-height: 90vh;
    width: 80vw;
    max-width: 1100px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    font-family: 'Inter', sans-serif;
`

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 24px 24px 0;
    flex-shrink: 0;
`

export const TitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;

    h2 {
        font-size: 18px;
        font-weight: 600;
        color: #262626;
        margin: 0;
    }
`

export const CloseButton = styled.button`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: none;
    background: #f4f4f4;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
    transition: background-color 0.2s ease;

    &:hover {
        background: #e8e8e8;
    }

    svg {
        color: #595959;
        display: block;
    }
`

export const StatusBadge = styled.span`
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    background-color: #EBEBEB;
    color: #595959;
    white-space: nowrap;

    &.completed {
        color: #2F9E50;
        background-color: rgba(179, 228, 191, 0.5);
    }

    &.pending {
        background-color: #FFFCEE;
        color: #9D7D07;
    }

    &.cancel {
        background-color: rgba(245, 142, 142, 0.4);
        color: #9D1E07;
    }
`

export const InfosContainer = styled.div`
    padding: 20px 24px 0;
    flex-shrink: 0;
`

export const Section = styled.div``

export const SectionSubtitle = styled.h3`
    font-size: 14px;
    font-weight: 600;
    color: #262626;
    margin: 0 0 12px;
`

export const SectionDivider = styled.div`
    height: 1px;
    background-color: #F0F0F0;
    margin: 20px 0;
`

export const InfoGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 16px;
`

export const FreightStatusDots = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
`

export const FreightStatusDot = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    font-size: 13px;
    font-weight: 600;
    color: #262626;
    user-select: none;
    white-space: nowrap;

    i {
        display: inline-block;
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #c2c2c2;
    }

    &.pending i {
        background-color: #0090D3;
    }

    &.notDelivered i {
        background-color: #D9534F;
    }

    &.completed i {
        background-color: #41BB5E;
    }
`

export const InfoItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`

export const InfoLabel = styled.span`
    font-size: 12px;
    color: #8C8C8C;
    font-weight: 400;
`

export const InfoValue = styled.span`
    font-size: 14px;
    color: #262626;
    font-weight: 600;
`

export const TableContainer = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: auto;
    padding: 0 24px;
    margin-top: 4px;

    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #999;
    }
`

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
`

export const HeaderRow = styled.tr``

export const HeaderCell = styled.th`
    text-align: left;
    padding: 8px 12px;
    background-color: #fff;
    font-size: 12px;
    font-weight: 500;
    color: #8C8C8C;
    position: sticky;
    top: 0;
    z-index: 2;
    border-bottom: 1px solid #F0F0F0;
    white-space: nowrap;
`

export const ItemRow = styled.tr`
    &:hover {
        background-color: #FAFAFA;
    }
`

export const ItemCell = styled.td`
    padding: 12px;
    font-size: 13px;
    color: #262626;
    border-bottom: 1px solid #F0F0F0;
    vertical-align: top;
    word-wrap: break-word;
    overflow-wrap: break-word;

    &.link a {
        color: #0090d3;
        cursor: pointer;
        text-decoration: none;
        font-weight: 500;
    }
`

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 16px 24px;
    border-top: 1px solid #F0F0F0;
    flex-shrink: 0;
    position: relative;
`

export const ButtonGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
`

export const AuditInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 12px;
    color: #8C8C8C;
`

export const ButtonDiv = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 10px 18px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    white-space: nowrap;
    background-color: #fff;
    color: #0090d3;
    border: 1px solid #0090d3;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #F0F9FF;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    &.primary {
        background-color: #0090d3;
        color: #fff;
        border: none;

        &:hover {
            background-color: #0078b0;
        }
    }
`

export const DriverListDiv = styled.div`
    position: absolute;
    bottom: 100%;
    right: 24px;
    margin-bottom: 0.5rem;
    display: flex;
    background-color: #fff;
    padding: 0.75rem;
    width: 14rem;
    max-height: 12rem;
    border: 1px solid #F0F0F0;
    border-radius: 8px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    flex-direction: column;
    align-items: stretch;
    overflow-y: auto;
    z-index: 10;

    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #999;
    }
`

export const DriverButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 10px 12px;
    margin-bottom: 6px;
    background-color: #FAFAFA;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
    color: #262626;
    text-align: left;
    transition: background-color 0.2s ease;

    &:last-child {
        margin-bottom: 0;
    }

    &:hover {
        background-color: #F0F9FF;
    }

    svg {
        color: #0090d3;
        flex-shrink: 0;
    }
`
